<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="menugrp_keyno" [ttModel]="menu.menugrp_keyno" ttReadonly></tt-input>
        <tt-input *ngIf="menu.menugrp_keyno === '0'" ttLabel="menugrp_name" [(ttModel)]="menu.menugrp_name"></tt-input>
        <tt-input *ngIf="menu.menugrp_keyno !== '0'" ttLabel="menugrp_name" [(ttModel)]="menu.menugrp_name" [ttButtons]="menuGroupNameButtons"></tt-input>
        <tt-input-number ttLabel="sortorder" [(ttModel)]="menu.sortorder" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-button-save ttText="menugrp_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
